import { useState, useEffect } from 'react'
import axios from 'axios'

import { services } from './servicios'

import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Whatsapp, Telephone } from 'react-bootstrap-icons';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import { isMobile } from 'react-device-detect';

import logo from './img/logo.png';
import footerTitle from './img/footer-title.png'
import send from './img/send.png'

import btlIcon from './img/btl_icon.jpg'
import arquitecturaIcon from './img/arquitectura_icon.jpg'
import printIcon from './img/print_icon.jpg'
import experienceIcon from './img/experience_icon.jpg'
import mediosIcon from './img/medios_icon.jpg'
import oohIcon from './img/ooh_icon.jpg'

import insta from './img/insta.png'
import face from './img/face.png'
import linked from './img/in.png'
import tik from './img/tik.png'
import youtube from './img/youtube.png'

import './App.css';
import 'animate.css';

function Services({ service }) {

  const [isLoading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')

  const [ serviceJson, setServiceJson ] = useState()
  const [imagenAmpliada, setImagenAmpliada] = useState(null)

  useEffect(() => {
    console.log('service', service)

    if( service ) {
      let path = service.replace('/', '')
      const result = services.find(({ id }) => id === path);

      if( result ) {
        setServiceJson( result )
        setImagenAmpliada( result.gallery[0] )
      }
    }
  }, []);

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
 
      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
 
      if (isScriptExist && callback) callback();
    }
 
    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleShow = () => setShowMessage(true);
  const handleOnSubmit = (event) => {
    event.preventDefault();
    
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute("6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5", { action: 'submit' }).then(token => {
        //if(isVerified){
        setLoading(true);
        //const recaptchaValue = recaptchaRef.current.getValue();
        var form = document.getElementById("contactForm");
        var formData = new FormData(form);
        formData.append('recaptcha_response', token);

        setLoading(true);
        axios.post("https://mgpublicidad.mx/mailer.php", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
          }).then(function(response) {

            if(response.data == "FAIL" || response.data == "ERROR") {
              setLoading(false)
              setTitle("Error")
              setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
              handleShow()
            } else {
              //window.location.href = "/gracias"
              setLoading(false)
              setTitle("Mensaje enviado")
              setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
              handleShow()

              setName("");
              setPhone("");
              setEmail("");
              setComments("");
            }

          }).catch(function(err) {
            setLoading(false)
            setTitle("Error")
            setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
            handleShow()
          });
      //} else 
        //alert("Por favor, verifica que no eres un robot")
      });
    });
  }

  const closeModalSent = () => {
    /*if( title == 'Error') setShowMessage(false)
    else window.location.href = "/"*/
    setShowMessage(false)
  }

  return (
    <>
      <Modal show={showMessage} onHide={ () => closeModalSent() }>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{ title }</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{ message }</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={ () => closeModalSent() }>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="App">
        <div>
          <div style={{ height: '110px' }} />
          <img src={serviceJson ? serviceJson.img : ''} className='banner-home'/>
        </div>

        <div className='banner-us' align="center">
          <Container className='service-section' style={{ borderBottom: '1px solid #000', paddingBottom: '10px' }}>
            <Row className='align-items-center'>
              <Col md={ 1 } xs={ 0 }/>
              { service !== '/btl' && 
                <Col md={ 2 } xs={ 4 }>
                  <a href='/btl'> <img src={btlIcon} className='services-icons' /> </a>
                </Col>
              }
              { service !== '/arquitectura' && 
                <Col md={ 2 } xs={ 4 }>
                  <a href='/arquitectura'> <img src={arquitecturaIcon} className='services-icons' /> </a>
                </Col>
              }
              { service !== '/experience' && 
                <Col md={ 2 } xs={ 4 }>
                  <a href='/experience'> <img src={experienceIcon} className='services-icons' /> </a>
                </Col>
              }
              { service !== '/medios' && 
                <Col md={ 2 } xs={ 4 }>
                  <a href='/medios'> <img src={mediosIcon} className='services-icons' /> </a>
                </Col>
              }
              { service !== '/ooh' && 
                <Col md={ 2 } xs={ 4 }>
                  <a href='/ooh'> <img src={oohIcon} className='services-icons' /> </a>
                </Col>
              }
              { service !== '/print' && 
                <Col md={ 2 } xs={ 4 }>
                  <a href='/print'> <img src={printIcon} className='services-icons' /> </a>
                </Col>
              }
              <Col md={ 1 } xs={ 0 }/>
            </Row>
          </Container>
        </div>
        
        <div className='banner-us' align="center">
          <Container className='service-section'>
            <Row>
              <Col>
                <div style={{ color: serviceJson ? serviceJson.color : '' }}>
                  <div className='services-title'>{ serviceJson ? serviceJson.title : '' }</div>
                  <div className='services-desc'>{ serviceJson ? serviceJson.desc : '' }</div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className='banner-us' align="center">
          <Container>
            <Row>
              <Col md={ 5 }>
                <Container>
                  <Row>
                    { serviceJson && serviceJson.gallery.map( item => (
                      <Col md={ 4 } className='service-gallery-container'> 
                        <div align="center"> <img src={ item } className='service-gallery-img' 
                          onClick={() => setImagenAmpliada(item)} 
                          //onMouseEnter={() => setImagenAmpliada(item)} 
                          //onMouseLeave={() => setImagenAmpliada(serviceJson.gallery[0])}
                        /> </div> 
                      </Col>
                    )) }
                  </Row>
                </Container>
                <br/>
                <div align="center"> <img src={ serviceJson ? serviceJson.imgContact : '' } className='service-gallery-contact'/> </div>
              </Col>
              <Col md={ 7 }>
                <div align="center"> <img src={ serviceJson ? imagenAmpliada : '' } className='service-gallery-img mobile-gallery'/> </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className='banner-us' align="center">
          <Container className='service-section'>
            <Row>
              <Col md={ 6 }>
                <div style={{ color: serviceJson ? serviceJson.color : '' }}>
                  <div className='services-list-title'>{ serviceJson ? serviceJson.servTitle : '' }</div>
                  <div className='services-list-desc'>
                    <ul>
                      { serviceJson && serviceJson.serv.map( item => (
                        <li>{ item }</li>
                      )) }
                    </ul>
                  </div>
                </div>
              </Col>
              <Col md={ 6 }>
                <div style={{ color: serviceJson ? serviceJson.color : '' }}>
                  <div className='services-list-title'>{ serviceJson ? serviceJson.staffTitle : '' }</div>
                  <div className='services-list-desc'>
                    <ul>
                      { serviceJson && serviceJson.staff.map( item => (
                        <li>{ item }</li>
                      )) }
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          
          { (serviceJson && serviceJson.footerSub) && 
            <>
              <br/>
              <br/>
              <div className='services-title' style={{ textAling: 'center', color: serviceJson.color, padding: 0 }}>{ serviceJson.footerSub }</div>
              <div className='services-footer-title' style={{ WebkitTextStrokeColor: serviceJson.color }}>{ serviceJson.footerTitle }</div>
            </>
          }

          <br/>
          <br/>
        </div>
       
        <div className='section' style={ serviceJson ? { backgroundColor: serviceJson.color } : {  } }>
          <div align="center">
            <div className='contact-container'>
            <Container>
              <Row>
                <Col md={ 12 }>
                  <Container>
                    <Row>
                      <Col md={ 7 }>
                        <div align={ isMobile ? "center" : "left" }> 
                          { !isMobile ?
                            <><img src={logo} height="60" className="d-inline-block" /> &nbsp;&nbsp;&nbsp;&nbsp;</>
                            :
                            <><img src={logo} height="60" className="d-inline-block" /><br/></>
                          }
                          <span className='service-footer-title'> COMENCEMOS A TRABAJAR JUNTOS </span>
                        </div>
                        <div><a href='mailto:contacto@mgpublicidad.mx'><div className='service-footer-text-link'>contacto@mgpublicidad.mx</div></a></div>
                      </Col>
                      <Col md={ 5 }>
                        <Container>
                          <br/>
                          <Row>
                            <Col md={ 1 } xs={ 1 } />
                            <Col md={ 2 } xs={ 2 }> <a href="https://www.facebook.com/AgenciaMGPublicidad/" target='_blank'> <img src={ face } className='rrss-icons' /> </a> </Col>
                            <Col md={ 2 } xs={ 2 }> <a href="https://www.instagram.com/agenciamgpublicidad/?igshid=a7zcmnd5sg1y" target='_blank'> <img src={ insta } className='rrss-icons' /> </a> </Col>
                            <Col md={ 2 } xs={ 2 }> <a href="https://www.youtube.com/@agenciamgpublicidad3543" target='_blank'> <img src={ youtube } className='rrss-icons' /> </a> </Col>
                            <Col md={ 2 } xs={ 2 }> <a href="https://www.tiktok.com/@agenciamgpublicidad" target='_blank'> <img src={ tik } className='rrss-icons' /> </a> </Col>
                            <Col md={ 2 } xs={ 2 }> <a href="https://mx.linkedin.com/company/mg-promociones" target='_blank'> <img src={ linked } className='rrss-icons' /> </a> </Col>
                            <Col md={ 1 } xs={ 1 } />
                          </Row>
                          <Row>
                            <Col>
                              <br/>
                              <div className='footer-text-desc mb-2' ><a href='tel:5568237495' target='_blank' > <Telephone /> &nbsp;&nbsp;55 6823 7495 </a></div>
                              <div className='footer-text-desc' ><a href='https://wa.me/5580947307' target='_blank' > <Whatsapp /> &nbsp;&nbsp;55 8094 7307 </a></div>
                            </Col>
                          </Row>
                        </Container>
                      </Col>
                    </Row>
                    
                  </Container>
                </Col>
                <Col md={ 12 } xs={ 12 }>
                  <br/>
                  <Container>
                    <Row>
                      <Col md={ 7 } xs={ 12 }>
                        <div className='form-container'>
                          <Form id="contactForm" onSubmit={ handleOnSubmit }>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                              <Form.Label></Form.Label>
                                <Form.Control required type="text" className='form-footer' style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }} placeholder="Nombre:" name='name' value={ name } onChange={ () => setName()}/>
                                <Form.Control required type="email" className='form-footer' style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }} placeholder="Email:" name='email' value={ email } onChange={ () => setEmail()}/>
                                <Form.Control required type="number" className='form-footer' style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }} placeholder="Teléfono:" name='phone' value={ phone } onChange={ () => setPhone()}/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                              <Form.Control required as="textarea" className='form-footer' style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }} placeholder="Mensaje:" rows={3} name='comments' value={ comments } onChange={ () => setComments()}/>
                            </Form.Group>
                              <div align="right"><Button disabled={isLoading} className="button-footer" style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }} type="submit" >{isLoading ? 'Enviando…' : 'ENVIAR'}</Button></div>
                          </Form>
                        </div>
                        <br/>
                      </Col>
                      <Col md={ 5 } xs={ 12 } className='footer-text-desc' align="center">
                        <div>
                          <div className='suscribe-container' style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }}>
                            <div>
                              <Form id="contactForm" onSubmit={ handleOnSubmit }>
                                <Container>
                                  <Row>
                                    <div className='footer-title' style={{ fontSize: '20px' }} align='left'> SUSCRÍBETE </div>
                                  </Row>
                                  <Row className='align-items-center mt-2'>
                                    <Col md={ 11 } style={{ borderBottom: '1px solid #fff' }}>
                                      <Form.Group>
                                        <Form.Control required type="text" className='form-footer form-footer-italic' style={serviceJson ? { backgroundColor: serviceJson.colorSec, borderColor: serviceJson.colorSec } : {  }} placeholder="Dirección de Correo" name='name' value={ name } onChange={ () => setName()}/>
                                      </Form.Group>
                                    </Col>
                                    { !isMobile && <Col md={ 1 }>
                                      <div> <img src={send} className='footer-icon'/> </div>
                                    </Col> }
                                  </Row>
                                  <Row>
                                    <Col>
                                      <br/>
                                      <div align="left">
                                        <Form.Check
                                          type={'radio'}
                                          label={`Acepto los términos y condiciones`}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Container>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Container>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Services;